<template>
  <section class="letterstripe">
    <div>abdchjavjkdvibncvdhcvdgewzgdksacvgsdagcjsgcvkagv<span>PHOTOGRAPHY</span>irfhsdfsdferizfgijhghjdsvchkds</div>
    <div>gcjjsdgiufpfirfhsdfsdcvgsdagijh<span>BUDAPEST</span>ghjdsvchjsgcvkagvkdsabdchjavjkdvibncvdhcvdgewzgdksa</div>
    <div>vdgcjjsdgiufpabdchjavjkdvibncvdhcfhsdfsdfe<span>ART</span>rizfgijhghjdsvchjsgcewzgdksacvgsdagvkagvkds</div>
  </section>
</template>

<script>
export default {
  name: "Letterstripe"
};
</script>

<style lang="scss">
.letterstripe {
  overflow: hidden;
  font-size: 60px;
  line-height: 38px;
  //color: #f4f4f4; //$lightgray; // or #efefef,  thicker spans are #ddd
  color: var(--color-letterstripe);
  //text-overflow: clip;
  text-transform: uppercase;
  letter-spacing: -5px;
  margin: 60px 0 70px 0;
  text-align: center;
  position: relative;
  height: 115px;
  user-select: none;
  clear: both;

  div {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    &:nth-child(2) {
      padding-left: 20px;
      top: 33.3%;
    }

    &:nth-child(3) {
      top: 66.6%;
    }
  }

  span {
    color: var(--color-letterstripe-bold);
    font-family: Averia, 'Courier New', Courier, monospace;
    font-size: 50px;
    //opacity: 0.7;
  }
}
</style>
